/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Status_OpenInputs */

const fr_payment_status_open = /** @type {(inputs: Payment_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente`)
};

/**

* @param {Payment_Status_OpenInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const payment_status_open = /** @type {((inputs?: Payment_Status_OpenInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Status_OpenInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_payment_status_open(inputs)
});